import React from "react";

function Pending() {
  return (
    <>
      <h2>Your bird is being built!</h2>
      <img
        src="https://cdn.pixabay.com/photo/2013/07/13/13/46/tux-161507_960_720.png"
        alt="Penguin with tools and hat"
      />
    </>
  );
}

export default Pending;